import React from "react";
import "./DeleteNodeButton.css";

interface Props {
  /** Activities currently inside — >0 means deleting also untags them. */
  count: number;
  /** "zone" | "level" — names the container in the prompt/tooltip. */
  scope: string;
  /** Delete the container: untag any activities (back to the untagged rail) and
   *  drop the now-empty row. */
  onConfirm: () => void;
}

const stop = (e: React.SyntheticEvent) => e.stopPropagation();

/** Delete a zone/level outright. Empty → removes the row immediately. Holds
 *  activities → a confirm that spells out they'll be untagged (never deleted),
 *  then untags them and removes the row. Sits next to "Untag all" in the head. */
const DeleteNodeButton: React.FC<Props> = ({ count, scope, onConfirm }) => {
  const [confirming, setConfirming] = React.useState(false);

  if (confirming) {
    return (
      <span className="takt-editor-delnode-confirm" onClick={stop}>
        <span className="takt-editor-delnode-prompt">
          Delete {scope} &amp; untag {count} {count === 1 ? "activity" : "activities"}?
        </span>
        <button
          type="button"
          className="takt-editor-delnode-yes"
          onClick={(e) => {
            stop(e);
            setConfirming(false);
            onConfirm();
          }}
        >
          Delete
        </button>
        <button
          type="button"
          className="takt-editor-delnode-no"
          onClick={(e) => {
            stop(e);
            setConfirming(false);
          }}
        >
          Cancel
        </button>
      </span>
    );
  }

  return (
    <button
      type="button"
      className="takt-editor-delnode-btn"
      aria-label={`Delete ${scope}`}
      title={
        count > 0
          ? `Delete this ${scope} — untags its ${count} ${count === 1 ? "activity" : "activities"} (back to the untagged rail) and removes the ${scope}`
          : `Delete this empty ${scope}`
      }
      onClick={(e) => {
        stop(e);
        if (count > 0) setConfirming(true);
        else onConfirm();
      }}
    >
      ✕
    </button>
  );
};

export default DeleteNodeButton;
